jQuery(function ($) {
    'use strict'

    new SliderManager();
    new DialogManager();
    new CartManager();
    new ExternalLinkManager();
    new VisibilityManager();
    new VatValidationManager();

    const distributorManager = new DistributorManager();
    distributorManager.loadDistributors();

    $('#CustomerEmail').focus();

    $('.page-konto .rich-text__buttons a').attr('tabindex', '5');
})